import { render, staticRenderFns } from "./BaseGridLayout.vue?vue&type=template&id=04014894"
import script from "./BaseGridLayout.vue?vue&type=script&lang=ts"
export * from "./BaseGridLayout.vue?vue&type=script&lang=ts"
import style0 from "./BaseGridLayout.vue?vue&type=style&index=0&id=04014894&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports